<template>
  <div class="audience-cta-wrapper">
    <div class="audience-cta">
      <button
        class="cta-button"
        @click="handleAudienceCtaClick"
      >
        {{ $t('review_slides') }}
      </button>
    </div>
  </div>
</template>

<script>
import EventBus from '@/eventBus'
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      slides: (state) => state.slides,
      slide: (state) => state.slide,
    }),
  },
  mounted() {
    document.body.classList.add('has-footer-cta')
  },
  destroyed() {
    document.body.classList.remove('has-footer-cta')
  },
  methods: {
    ...mapActions([
      'setMaxLookbackSlideIndexAction',
    ]),
    handleAudienceCtaClick() {
      this.setMaxLookbackSlideIndexAction(this.slides.length - 1)
      EventBus.$emit('changeTab', 'lookback')
    },
  },
}
</script>

<style lang="scss" scoped>
.audience-cta-wrapper {
  -webkit-user-select: none; /* Chrome all / Safari all */
  -moz-user-select: none; /* Firefox all */
  -ms-user-select: none; /* IE 10+ */
  user-select: none; /* Likely future */
  text-decoration: none;
}

.audience-cta {
  background: #ffffff;
  padding: 16px 16px 18px 16px;
  width: 100%;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.08);
  text-align: center;

  .cta-button {
    width: 100%;
  }

  @media screen and (min-width: 768px) {
    .cta-button {
      width: auto;
    }
  }
}

.audience-cta__description {
  color: #4b4b4b;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  margin: 0 0 8px;
}

.cta-button {
    -webkit-text-size-adjust: 100%;
  --rem: 16;
  tab-size: 4;
  box-sizing: border-box;
  border-width: 0;
  border-style: solid;
  border-color: currentColor;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59, 130, 246, 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  font-family: inherit;
  margin: 0;
  text-transform: none;
  background-image: none;
  cursor: pointer;
  -webkit-transform-style: preserve-3d;
  -webkit-backface-visibility: hidden;
  font-weight: 700;
  min-width: 2.5rem;
  --tw-text-opacity: 1;
  color: rgba(245, 245, 245, var(--tw-text-opacity));
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 100ms;
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  --tw-bg-opacity: 1;
  background-color: rgba(52, 142, 246, var(--tw-bg-opacity));
  --tw-shadow: 0 4px 0px #257ADC;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  height: 2.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  -webkit-appearance: button;
  padding: 8px 20px;

  &:hover:not(:active):not(:disabled) {
    --tw-shadow: 0px 3px 0px #257ADC;
    --tw-translate-y: 0.0625rem;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  &:focus {
    outline: none !important;
  }

  &:active:not(:disabled) {
    --tw-bg-opacity: 1;
    background-color: rgba(37, 122, 220, var(--tw-bg-opacity));
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    --tw-translate-y: 0.25rem;
  }
}
</style>
